

import { Controller } from "@hotwired/stimulus";

const LIFETRACKER_RESIZE_MESSAGE_TYPE = "lifetracker:resize";

export default class extends Controller {

  connect() {
  }

  toggle(event) {
    const targetId = event.currentTarget.dataset.toggleTargetId;
    const targetElement = document.getElementById(targetId);
    var result;

    if (targetElement) {
      result = targetElement.classList.toggle("hidden");
    }
    var multiplier = 1;

    if (result) {
      // hidden was added, which means shrink the current window
      multiplier = 0.5;
    } else {
      multiplier = 2;
    }

    var currentHeight = window.outerHeight;
    var currentWidth = window.outerWidth;

    var newHeight = currentHeight * multiplier;
    window.resizeTo(currentWidth, newHeight);
    this.requestParentResize(currentWidth, newHeight, multiplier);
  }

  requestParentResize(width, height, multiplier) {
    if (window.parent === window) {
      return;
    }

    window.parent.postMessage({
      type: LIFETRACKER_RESIZE_MESSAGE_TYPE,
      width,
      height,
      multiplier
    }, window.location.origin);
  }
}
